import type { ComponentProps } from 'react';
import { FIELD_GEOMETRY, fieldClass } from '../../lib/surfaces';

/** Browser-native keyboard behavior for simple forms; the design system's recessed field. */
export function NativeSelect({ className, ...props }: ComponentProps<'select'>) {
  return (
    <select
      data-slot="native-select"
      className={fieldClass(FIELD_GEOMETRY, 'min-w-0', className)}
      {...props}
    />
  );
}
